import styled from 'styled-components'
import { COLORS, SHADOWS } from 'tokens'

// Each section gets its width & min-width from parent component
export const Column = styled.div`
  width: 33%;
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  min-width: 418px;
  max-height: 851px;
  padding: 20px;
  overflow-y: auto;
  overflow-x: hidden;
`
